/**
 * De dónde llegó quien se registra: el sitio pasa los utm_* (o gclid/fbclid, o el
 * dominio que lo trajo) en los enlaces a la app. Se guardan aquí al entrar, antes
 * de que el inicio de sesión cambie la URL, y la app los manda una sola vez a la
 * API con la sesión ya abierta. Sin cookies: solo este navegador.
 */
import type { Origen } from '@eco/shared'

const KEY = 'eco.origen'
const ENVIADO = 'eco.origen.enviado'

const PARAMS: [string, keyof Origen][] = [
  ['utm_source', 'fuente'],
  ['utm_medium', 'medio'],
  ['utm_campaign', 'campana'],
  ['utm_content', 'contenido'],
  ['utm_term', 'termino'],
  ['gclid', 'gclid'],
  ['fbclid', 'fbclid'],
  ['ref', 'ref'],
  ['landing', 'landing']
]

/** Lee el origen de la URL. Gana la primera visita con datos (la que trajo a la persona). */
export function capturarOrigen(search: string, storage: Storage | undefined = safeStorage()) {
  if (!storage) return
  const q = new URLSearchParams(search)
  const o: Origen = {}
  for (const [param, campo] of PARAMS) {
    const v = q.get(param)?.trim()
    if (v) o[campo] = v.slice(0, 200)
  }
  if (!Object.keys(o).length) return
  try {
    if (storage.getItem(ENVIADO) || storage.getItem(KEY)) return
    storage.setItem(KEY, JSON.stringify(o))
  } catch {
    /* sin almacenamiento: no se registra el origen */
  }
}

/** El origen guardado que falta mandar a la API, si hay. */
export function origenPendiente(storage: Storage | undefined = safeStorage()): Origen | null {
  if (!storage) return null
  try {
    if (storage.getItem(ENVIADO)) return null
    const raw = storage.getItem(KEY)
    return raw ? (JSON.parse(raw) as Origen) : null
  } catch {
    return null
  }
}

export function marcarOrigenEnviado(storage: Storage | undefined = safeStorage()) {
  try {
    storage?.setItem(ENVIADO, '1')
    storage?.removeItem(KEY)
  } catch {
    /* nada que hacer */
  }
}

function safeStorage(): Storage | undefined {
  try {
    return typeof localStorage === 'undefined' ? undefined : localStorage
  } catch {
    return undefined
  }
}
